module.exports = __webpack_public_path__ + "img/bg_iot.8f31ddac.png";